<template>
  <v-fade-transition hide-on-leave>
    <template v-if="isLoading">
      <v-overlay :opacity="0">
        <LoadingIcon />
      </v-overlay>
    </template>
    <template v-else>
      <iframe
        :src="url"
        width="100%"
        height="105%"
        frameborder="0"
        marginheight="0"
        marginwidth="0" />
    </template>
  </v-fade-transition>
</template>

<script>
import LoadingIcon from '../components/SVGs/LoadingIcon';
import storeUtils from '../libs/storeUtils';

export default {
  components: {
    LoadingIcon,
  },
  data() {
    return {
      url: '',
      isLoading: true,
    };
  },
  created: async function() {
    this.$store.dispatch('initialLoginState', true);

    // 思い出一覧やユーザデータの取得
    if (this.$store.state.memories.length === 0) {
      this.isLoading = true;
      await storeUtils.getAllData(this.$store, this.$ga);
    }

    // 必要なデータをGoogle formの事前入力に設定する
    this.url = process.env.VUE_APP_INQUIRY_URL
      .replace('userIdAnswer', this.$store.state.profile.userId)
      .replace('currentUserIdAnswer', this.$store.state.currentUserId);

    this.isLoading = false;
  },
};
</script>